import * as style from './style.css';
import { Responsive } from '@cian/ui-kit';
import type * as React from 'react';
import { ReactNode } from 'react';

interface IBuildingProps {
  header: ReactNode;
  address: ReactNode;
  description: ReactNode;
  layoutLinks: ReactNode;
}

export const BuildingWrapper = ({ header, address, description, layoutLinks }: IBuildingProps): React.JSX.Element => {
  return (
    <div className={style['container']}>
      {header}
      {address}

      <Responsive desktop>{description}</Responsive>

      {layoutLinks}
    </div>
  );
};
